import { type SVGProps } from "react";

export function ChartIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33359 2.66698C7.03001 2.96918 5.83102 3.61464 4.86099 4.53642C3.89095 5.45821 3.18521 6.62273 2.81694 7.90921C2.44868 9.19569 2.43132 10.5573 2.76666 11.8527C3.102 13.1482 3.77783 14.3303 4.72404 15.2765C5.67026 16.2227 6.8524 16.8986 8.14785 17.2339C9.4433 17.5692 10.8049 17.5519 12.0914 17.1836C13.3778 16.8154 14.5424 16.1096 15.4641 15.1396C16.3859 14.1695 17.0314 12.9706 17.3336 11.667C17.3336 11.446 17.2458 11.234 17.0895 11.0777C16.9332 10.9214 16.7213 10.8336 16.5003 10.8336H10.8336C10.3916 10.8336 9.96764 10.658 9.65508 10.3455C9.34252 10.0329 9.16692 9.60901 9.16692 9.16698V3.33364C9.15657 3.23492 9.12672 3.13922 9.0791 3.05212C9.03148 2.96501 8.96705 2.88823 8.88953 2.82621C8.81201 2.7642 8.72296 2.71819 8.62752 2.69086C8.53209 2.66352 8.43218 2.65541 8.33359 2.66698Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5003 2.91698C13.5584 3.28955 14.5194 3.89473 15.3126 4.68794C16.1058 5.48116 16.711 6.44221 17.0836 7.50031H13.3336C13.1126 7.50031 12.9006 7.41251 12.7443 7.25623C12.5881 7.09995 12.5003 6.88799 12.5003 6.66698V2.91698Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChartFillIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 3C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18ZM15.707 9.293C15.5195 9.10553 15.2652 9.00021 15 9.00021C14.7348 9.00021 14.4805 9.10553 14.293 9.293L12 11.585L10.707 10.293C10.5195 10.1055 10.2652 10.0002 10 10.0002C9.73484 10.0002 9.48053 10.1055 9.293 10.293L6.293 13.293C6.10553 13.4805 6.00021 13.7348 6.00021 14C6.00021 14.2652 6.10553 14.5195 6.293 14.707L6.387 14.79C6.5794 14.9393 6.81966 15.0132 7.06268 14.9979C7.30571 14.9826 7.53481 14.8792 7.707 14.707L10 12.415L11.293 13.707L11.387 13.79C11.5794 13.9393 11.8197 14.0132 12.0627 13.9979C12.3057 13.9826 12.5348 13.8792 12.707 13.707L15 11.415L16.293 12.707C16.4816 12.8892 16.7342 12.99 16.9964 12.9877C17.2586 12.9854 17.5094 12.8802 17.6948 12.6948C17.8802 12.5094 17.9854 12.2586 17.9877 11.9964C17.99 11.7342 17.8892 11.4816 17.707 11.293L15.707 9.293Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChartPieFillIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.88299 2.20838C10.3587 2.15232 10.8379 2.27797 11.2249 2.56018C11.6119 2.8424 11.878 3.26034 11.97 3.73038L11.995 3.89738L12 4.00138V11.0014C12 11.2463 12.0899 11.4827 12.2527 11.6657C12.4155 11.8488 12.6397 11.9657 12.883 11.9944L13 12.0014H19.8C20.3304 12.0014 20.8391 12.2121 21.2142 12.5872C21.5893 12.9622 21.8 13.4709 21.8 14.0014C21.7999 14.0775 21.7912 14.1533 21.774 14.2274C21.3738 15.954 20.5219 17.5433 19.3055 18.8324C18.0891 20.1216 16.5519 21.0642 14.8513 21.5639C13.1508 22.0636 11.348 22.1023 9.62757 21.6761C7.90715 21.2499 6.33092 20.3741 5.06029 19.1383C3.78967 17.9026 2.87031 16.3514 2.39636 14.6435C1.92242 12.9356 1.91092 11.1324 2.36305 9.41862C2.81517 7.70482 3.71468 6.14199 4.96944 4.89016C6.22421 3.63833 7.78914 2.74249 9.50399 2.29438L9.77399 2.22738L9.88399 2.20738L9.88299 2.20838Z"
        fill="currentColor"
      />
      <path
        d="M14 3.50138V9.00138C14 9.26659 14.1053 9.52095 14.2929 9.70848C14.4804 9.89602 14.7348 10.0014 15 10.0014H20.5C20.6598 10.0013 20.8173 9.96297 20.9593 9.88952C21.1012 9.81606 21.2235 9.70964 21.3159 9.57919C21.4082 9.44873 21.468 9.29804 21.4901 9.13974C21.5122 8.98144 21.4961 8.82015 21.443 8.66938C20.9463 7.25871 20.1396 5.97741 19.0822 4.91981C18.0247 3.86222 16.7436 3.05527 15.333 2.55838C15.1822 2.50511 15.0208 2.4888 14.8623 2.51082C14.7039 2.53285 14.5531 2.59255 14.4225 2.68493C14.2919 2.77731 14.1854 2.89967 14.1119 3.04173C14.0383 3.18379 14 3.34142 14 3.50138Z"
        fill="currentColor"
      />
    </svg>
  );
}
